export default function initTabs(): void {
    const $tabsContainer = document.querySelectorAll<HTMLElement>('.tabs-block');

    $tabsContainer.forEach($container => {
        new tabsContainer($container);
    });
}

class tabsContainer {
    $el: HTMLElement | null | undefined;
    $tabs: NodeListOf<HTMLElement> | null | undefined;
    $desktopTabsButtonsWrapper: HTMLElement | null | undefined;
    $mobileTabsButtonsWrapper: HTMLElement | null | undefined;
    $defaultActiveTab: HTMLElement | null | undefined;
    mdBreakpoint: number;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$tabs = $el?.querySelectorAll('.tab-content');
        this.$desktopTabsButtonsWrapper = $el?.querySelector('.tabs.only-desktop');
        this.$mobileTabsButtonsWrapper = $el?.querySelector('.tabs.only-mobile');
        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));
        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
    }

    onWindowResize() {
        if (window.innerWidth > this.mdBreakpoint) {
            this.desktopTabHandler();

        } else if (window.innerWidth <= this.mdBreakpoint) {
            this.mobileTabHandler();
        }
    }

    desktopTabHandler() {
        const desktopButtons = this.$desktopTabsButtonsWrapper?.querySelectorAll('.tab');

        desktopButtons?.forEach((button) => {
            const activeButtonDataTarget = button.getAttribute('data-tab-target');
            button.addEventListener('click', ()=> {
                if (!button.classList.contains('active')) {
                    desktopButtons?.forEach(button => button.classList.remove('active'))
                    button.classList.add('active');
                }

                this.$tabs?.forEach((tab) => {
                    if(activeButtonDataTarget === tab.getAttribute('data-tab')) {
                        this.$tabs?.forEach(tab => tab.classList.remove('active'));
                        tab.classList.add('active');

                    }
                })
            })
        })
    }

    mobileTabHandler() {
        const select = this.$mobileTabsButtonsWrapper?.querySelector('.tabs-select') as HTMLSelectElement;
        const activeTab = this.$el?.querySelector('.tab-content.active') as HTMLElement;
        select.value = activeTab.getAttribute('data-tab') as string;

        select.addEventListener('change', () => {
            this.$tabs?.forEach((tab) => {
                if (select.value === tab.getAttribute('data-tab')) {
                    this.$tabs?.forEach(tab => tab.classList.remove('active'));
                    tab.classList.add('active');
                }
            })
        })
    }
}
